import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IVoucherDetail } from "src/models/Prices/Voucher.models";

interface VoucherDetailState {
  voucherDetails: IVoucherDetail[];
  voucherDetailToEdit: IVoucherDetail | null;
}

const initialState: VoucherDetailState = {
  voucherDetails: [],
  voucherDetailToEdit: null,
};

const VoucherDetailSlice = createSlice({
  name: "VoucherDetail",
  initialState,
  reducers: {
    setVoucherDetailList: (state, action: PayloadAction<IVoucherDetail[]>) => {
      state.voucherDetails = action.payload;
    },
    setVoucherDetailToEdit: (
      state,
      action: PayloadAction<IVoucherDetail | null>
    ) => {
      state.voucherDetailToEdit = action.payload;
    },
    concatListVoucherDetail: (
      state: VoucherDetailState,
      action: PayloadAction<IVoucherDetail[]>
    ) => {
      state.voucherDetails = [...state.voucherDetails.concat(action.payload)];
    },
    addVoucherDetail: (state, action: PayloadAction<IVoucherDetail>) => {
      state.voucherDetails.push(action.payload);
    },
    updateVoucherDetail: (state, action: PayloadAction<IVoucherDetail>) => {
      let itemIndex = state.voucherDetails.findIndex(
        item => item.voucherDetailId === action.payload.voucherDetailId
      );
      if (itemIndex !== -1) state.voucherDetails[itemIndex] = action.payload;
    },
    deleteVoucherDetail: (state, action: PayloadAction<number>) => {
      const newArray = state.voucherDetails.filter(
        item => item.voucherDetailId !== action.payload
      );
      state.voucherDetails = newArray;
    },
  },
});

export const {
  setVoucherDetailList,
  concatListVoucherDetail,
  setVoucherDetailToEdit,
  addVoucherDetail,
  updateVoucherDetail,
  deleteVoucherDetail,
} = VoucherDetailSlice.actions;

export default VoucherDetailSlice.reducer;
